export default "__VITE_ASSET__CyDeleBh__"